import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Download } from 'lucide-react';
import { api } from '../lib/api';
import { usePageMeta } from '../components/layout/Page';
import { ModelViewer } from '../components/model/ModelViewer';
import { useAuth } from '../lib/auth';

export default function Demo() {
  const { slug } = useParams();
  const { session } = useAuth();
  const [results, setResults] = useState(null);
  const [granularity, setGranularity] = useState('monthly');
  const [scenario, setScenario] = useState('base');
  const [section, setSection] = useState('overview');
  const [error, setError] = useState('');
  usePageMeta('Interactive sample model', 'Explore a synthetic-data financial model without signing up.');
  useEffect(() => { let active = true; setError(''); api.demo(slug, granularity).then((value) => { if (active) setResults(value); }).catch((e) => { if (active) setError(e.message); }); return () => { active = false; }; }, [slug, granularity]);
  if (error) return <div className="container-x py-24 text-sm text-rose-700" data-testid="demo-error">{error}</div>;
  if (!results) return <div className="container-x py-24 text-sm text-muted-foreground" data-testid="demo-loading">Calculating the sample model…</div>;
  const buildTo = session ? `/app/models/new?template=${slug}` : `/signup?next=${encodeURIComponent(`/app/models/new?template=${slug}`)}`;
  return <div className="container-x py-10">
    <div className="mb-6 flex flex-wrap items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-testid="demo-banner">
      <span className="rounded border border-amber-300 px-1.5 text-[10px] font-semibold">SAMPLE DATA</span>
      <span>This is a synthetic example — read-only. Nothing here is saved. To use your own numbers, create a free private model.</span>
      <div className="ml-auto flex gap-2"><a href={api.sampleUrl(slug)} className="btn-secondary h-9" data-testid="demo-download"><Download size={14} /> Sample .xlsx</a><Link to={buildTo} className="btn-primary h-9" data-testid="demo-build">Build with my numbers</Link></div>
    </div>
    <h1 className="h2 mb-6" data-testid="demo-title">{results.project.name}</h1>
    <ModelViewer results={results} project={results.project} scenario={scenario} setScenario={setScenario} granularity={granularity} setGranularity={setGranularity} section={section} setSection={setSection} />
  </div>;
}
